itsoftApp.createModule("tooltips", ["cookie"], function () {
    var module = this;
    var openTooltipButtons = document.querySelectorAll(".js-open-tooltip");
    var activeTooltips = document.querySelectorAll("[data-tooltip-opened='true']");

    var initTooltips = function () {
        var initTooltip = function (openButton, tooltip) {
            var tooltipElement = tooltip;
            var closeButtons;
            var openButton;
            var checkbox;

            console.log()

            var onOpenButtonClick = function (evt) {
                evt.preventDefault();

                var tooltipSelector = openButton.getAttribute("data-tooltip");
                tooltipElement = document.querySelector(tooltipSelector);

                if (evt.currentTarget.classList.contains("js-mobile-popup")) {
                    var desktopContainer = tooltipElement.closest(".js-desktop-container");
                    if (itsoftApp.utils.getViewportSize() <= 1023) {
                        var popupContainer = document.querySelector("#popup-box");
                        popupContainer.appendChild(tooltipElement);
                    } else {
                        desktopContainer.appendChild(tooltipElement);
                    }
                }

                openTooltip();
            }

            var onBoxCheck = function (evt) {
                if (evt.currentTarget.classList.contains("js-error")) {
                    checkbox.classList.remove("js-error");
                    checkbox.removeEventListener("change", onBoxCheck);
                }
            }

            var closeTooltip = function () {
                tooltipElement.classList.remove("is-opened");
                Array.prototype.forEach.call(closeButtons, function (closeButton) {
                    closeButton.removeEventListener("click", onCloseButtonClick);
                });
            }

            var onCloseButtonClick = function (evt) {
                evt.preventDefault();
                closeTooltip();
                if (evt.currentTarget.classList.contains("js-save")) {
                    if (evt.currentTarget.hasAttribute("data-checkbox")) {
                        var checkboxID = evt.currentTarget.getAttribute("data-checkbox");
                        checkbox = tooltipElement.querySelector(checkboxID);

                        if (!checkbox.checked) {
                            checkbox.classList.add("js-error");
                            checkbox.addEventListener("change", onBoxCheck);
                            return;
                        }
                    }

                    itsoftApp.modules.cookie.setCookie(this, 2147483647);
                }
            }

            var openTooltip = function () {
                tooltipElement.classList.add("is-opened");
                closeButtons = tooltipElement.querySelectorAll(".js-close-tooltip");
                Array.prototype.forEach.call(closeButtons, function (closeButton) {
                    closeButton.addEventListener("click", onCloseButtonClick);
                })
            }

            if (openButton) {
                openButton.addEventListener("click", onOpenButtonClick);
            }

            // if (tooltip) {
            //     var dAttrSave = tooltip.getAttribute("data-save");
            //     if (dAttrSave && !(itsoftApp.modules.cookie.getCookie(tooltip))) {
            //         openTooltip();
            //     } else if (!dAttrSave) {
            //         openTooltip();
            //     }
            // }
        }

        if (openTooltipButtons) {
            Array.prototype.forEach.call(openTooltipButtons, function (openButton) {
                initTooltip(openButton);
            });
        }

        if (activeTooltips) {
            Array.prototype.forEach.call(activeTooltips, function (el) {
                initTooltip(null, el);
            });
        }
    }

    initTooltips();

    module.callback = initTooltips;
});